module.exports = __webpack_public_path__ + "static/img/money-important.ba2afad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/money-important.png
// module id = ck8E
// module chunks = 1